import { sendFirebaseEvent } from "./firebaseTracker";
import type {
  FirebaseEventName,
  FirebaseEventParamsMap,
  FirebaseScreenId,
} from "./types";

/**
 * 依頼書 §3 の共通計測モジュール。
 * 「今どの画面にいるか」を記録し、全イベントに source(遷移元の画面ID) を自動付与する。
 */

/** 遷移確定時に決めた screen_view の中身。送信は画面の描画完了（screenRender の確定）まで遅らせる */
export type PendingScreenView = {
  screenId: FirebaseScreenId;
  source: string;
};

let currentScreen = "unknown";
let previousScreen = "unknown";

/**
 * 現在画面を切り替える（ルート遷移の確定時）。以降のイベントの source はこの画面になる。
 * 戻り値を trackFirebaseScreenView に渡して送信する（送信だけ描画完了まで遅らせるため分離している）。
 * 画面IDは FIREBASE_SCREEN_ID の値のみ（クラス名・ルートパス禁止）。
 */
export const setFirebaseCurrentScreen = (
  screenId: FirebaseScreenId,
): PendingScreenView => {
  previousScreen = currentScreen;
  currentScreen = screenId;
  return { screenId, source: previousScreen };
};

/** 画面表示イベントを送信する。source は setFirebaseCurrentScreen 時点の遷移元画面 */
export const trackFirebaseScreenView = (view: PendingScreenView): void => {
  sendFirebaseEvent("screen_view", {
    screen_name: view.screenId,
    source: view.source,
  });
};

/**
 * Firebase Analytics イベントの送信エントリーポイント。
 * イベント名・パラメータは types.ts のイベント辞書で型強制され、source は自動で付く。
 */
export const trackFirebaseEvent = <K extends FirebaseEventName>(
  eventName: K,
  params: FirebaseEventParamsMap[K],
): void => {
  sendFirebaseEvent(eventName, { ...params, source: currentScreen });
};

/** テスト用: 画面状態をリセットする */
export const resetFirebaseScreenState = (): void => {
  currentScreen = "unknown";
  previousScreen = "unknown";
};
